import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="orders-users-select"
export default class extends Controller {
  static targets = ["field", "panel", "toggle", "count", "item"];

  static values = { immediate: Boolean };

  connect() {
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this);
  }

  disconnect() {
    window.removeEventListener("click", this.closeOnOutsideClick);
    this.clearHighlight();
  }

  toggle() {
    this.open = this.panelTarget.hidden;
  }

  set open(value) {
    this.toggleTarget.setAttribute("aria-expanded", value);
    this.panelTarget.hidden = !value;

    if (value) {
      window.addEventListener("click", this.closeOnOutsideClick);
    } else {
      window.removeEventListener("click", this.closeOnOutsideClick);
    }
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) this.open = false;
  }

  filter(event) {
    const query = event.target.value.trim().toLowerCase();

    for (const item of this.itemTargets) {
      const label = this.nameIn(item);
      const at = label.dataset.name.toLowerCase().indexOf(query);

      item.hidden = at < 0 && !this.checkboxIn(item).checked;
      this.emphasize(label, at, query.length);
    }
  }

  select() {
    this.sync();
    if (this.immediateValue) this.fieldTarget.form.requestSubmit();
  }

  reset() {
    for (const item of this.itemTargets) this.checkboxIn(item).checked = false;

    this.sync();
    this.fieldTarget.form.requestSubmit();
  }

  sync() {
    const selected = this.itemTargets.filter((item) => this.checkboxIn(item).checked);

    this.countTarget.textContent = selected.length;
    this.fieldTarget.value = selected.map((item) => item.dataset.memberId).join(",");
  }

  highlight(event) {
    for (const order of this.ordersOf(event.currentTarget.dataset.memberId)) {
      order.classList.add("is-highlighted");
    }
  }

  clearHighlight() {
    for (const order of document.querySelectorAll(".is-highlighted")) {
      order.classList.remove("is-highlighted");
    }
  }

  // Rebuilds the name with the matched run wrapped in <strong>. Text nodes only, so a
  // member name is never parsed as markup.
  emphasize(label, at, length) {
    const name = label.dataset.name;

    label.textContent = "";

    if (at < 0 || length === 0) {
      label.textContent = name;
      return;
    }

    const match = document.createElement("strong");
    match.textContent = name.slice(at, at + length);
    label.append(name.slice(0, at), match, name.slice(at + length));
  }

  ordersOf(memberId) {
    return [...document.querySelectorAll("[data-participant-ids]")].filter((order) =>
      order.dataset.participantIds.split(" ").includes(memberId)
    );
  }

  checkboxIn(item) {
    return item.querySelector("input[type=checkbox]");
  }

  nameIn(item) {
    return item.querySelector("[data-name]");
  }
}
